var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 11,
    rx: 1,
    fill: "#A4A6B3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 13,
    width: 7,
    height: 3,
    rx: 1,
    fill: "#A4A6B3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 5,
    width: 7,
    height: 11,
    rx: 1,
    fill: "#A4A6B3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    width: 7,
    height: 3,
    rx: 1,
    fill: "#A4A6B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMenuIcon);
export default __webpack_public_path__ + "static/media/dashboard-menu-icon.e02e99312270c510e81b4a033f58806d.svg";
export { ForwardRef as ReactComponent };